const config = window.APP_CONFIG;

const emailTemplatesEN = [
  // 0. CEO Fraud (empty)
  {
    id: 0,
    language: "en",
    subject: "Quick response",
    body: `<p>Hello {{nickname}}</p><p>I’m currently in a meeting and need you to quickly complete a task for me. Send me your WhatsApp number and wait for my message.</p>
    <p class="pt-4">Kind regards,</p><p>${config.CEO}</p>`,
    sender: `${config.CEO} <alainhenrard76@gmail.com>`,
    isPhishing: true,
    footer: ``
  },

  // 1. Security Mail – suspicious login
  {
    id: 1,
    language: "en",
    subject: "Unusual sign-in activity detected",
    body: `
    <div style="text-align:center;">
      <img src="/images/microsoft.png" alt="Microsoft logo" style="display:block; margin: 0 auto; height: 150px;" />

      <p class="pb-4" style="font-size:15px; line-height:1.6; color:#333;">
        We noticed a sign-in attempt on your Microsoft account from a new device or location.
      </p>

      <p style="font-size:15px; line-height:1.6; color:#333;">
        We recommend checking your account settings immediately.
      </p>

      <div style="margin: 24px 0;">
        <a href="https://micr0s0ft.com/login" style="background:#dc3545;color:white;padding:12px 20px;border-radius:4px;text-decoration:none;font-weight:bold;">
          Review activity
        </a>
      </div>

      <p style="font-size:13px; color:#666;">Activity detected: June 5, 2025 at 10:42 AM (CET)</p>
    </div>
  `,
    sender: "Microsoft Security <security@micr0s0ft.com>",
    isPhishing: true,
    footer: `
    <div style="font-size:12px; color:#888; padding-top:10px; text-align:center;">
      This email was generated automatically. Do not reply directly to this message.<br />
      Visit your <a href="https://account.microsoft.com/security" style="color:#dc3545; text-decoration:underline;">security settings</a> for more information.
    </div>
  `
  },

  // 2. Internal Events – signup
  {
    id: 2,
    language: "en",
    subject: "Invitation: On-site teambuilding – sign up now",
    body: `
    <div style="text-align:center;">
      <p style="font-size:15px; line-height:1.6; color:#333;">Hello {{nickname}},</p>

      <p style="font-size:15px; line-height:1.6; color:#333;">
        Registration is now open for our next teambuilding event.
      </p>

      <p style="font-size:15px; line-height:1.6; color:#333;">
        We're looking forward to a successful day together!
      </p>

      <div style="margin: 24px 0;">
        <a href="https://${config.companyDomain}/inschrijven" style="background:#007bff;color:white;padding:12px 20px;border-radius:4px;text-decoration:none;font-weight:bold;">
          Sign up
        </a>
      </div>
    </div>
  `,
    sender: `Event Team <events@${config.companyDomain}>`,
    isPhishing: false,
    footer: `
    <div style="font-size:12px; color:#888; padding-top:10px; text-align:center;">
      This invitation was sent by the internal event team.<br />
      Questions? Contact <a href="mailto:events@${config.companyDomain}" style="text-decoration:underline;color:#007bff;">events@${config.companyDomain}</a>
    </div>
  `
  },

  // 3. Holiday – Christmas party
  {
    id: 3,
    language: "en",
    subject: "🎄 Invitation: Office Christmas Party",
    body: `
    <div style="text-align:center;">
      <img src="/images/christmas.jpg" alt="Christmas party" style="display:block; margin: 0 auto;height:150px;margin-bottom:12px;" />
      <p>Dear Colleagues</p>
      <p style="font-size:15px;">🎅 Our annual Christmas party is coming up! Will you join?</p>
      <p style="font-size:15px;">Register below to confirm your attendance.</p>
      <div style="margin:16px 0;">
        <a href="https://${config.companyDomain}/kerstfeest" style="background:#00aca9;color:white;padding:10px 16px;border-radius:4px;text-decoration:none;">I'm in</a>
      </div>
      </div>
  `,
    sender: `HR Department <hr@${config.companyDomain}>`,
    isPhishing: false,
    footer: `<div style="font-size:12px;color:#888;text-align:center;">
      Organized by HR. Please reply by December 15.
    </div>`
  },

  // 4. IT – software update
  {
    id: 4,
    language: "en",
    subject: "Important security update required – complete today",
    body: `
    <div style="text-align:center;">
      <p class="pb-4" style="font-size:15px; line-height:1.6; color:#333;">Good morning {{nickname}},</p>

      <p class="pb-4" style="font-size:15px; line-height:1.6; color:#333;">
        A critical security update is available for your workstation. To minimize risks, we ask you to install it today.
      </p>

      <p style="font-size:15px; line-height:1.6; color:#333;">
        Click the button below to start the update immediately.
      </p>

      <div style="margin: 24px 0;">
        <a href="https://${config.companyDomainPhishing}/update" style="background:#ffc107;color:black;padding:12px 20px;border-radius:4px;text-decoration:none;font-weight:bold;">
          Start update
        </a>
      </div>

      <p style="font-size:13px; color:#666;">
        Update ID: KB509821 — available since ${new Date().toLocaleDateString('en-GB')}
      </p>
    </div>
  `,
    sender: `IT Support <it@${config.companyDomainPhishing}>`,
    isPhishing: true,
    footer: `
    <div style="font-size:12px; color:#888; padding-top:10px; text-align:center;">
      Questions? Contact <a href="mailto:it@${config.companyDomainPhishing}" style="text-decoration:underline;color:#ffc107;">it@${config.companyDomainPhishing}</a><br />
      This message was automatically sent by the IT management system.
    </div>
  `
  },

  // 5. Account Notification – new reply
  {
    id: 5,
    language: "en",
    subject: "Someone replied to your post",
    body: `
      <div style="text-align:center;">
        <img src="/images/linkedin.png" alt="LinkedIn" style="display:block;margin:0 auto;height:200px;" />
        <p style="font-size:15px; line-height:1.6;">Someone just commented on one of your recent posts.</p>
        <p style="font-size:15px; line-height:1.6;">View the comment and join the conversation.</p>
        <div style="margin:20px 0;">
          <a href="https://www.Iinkedin/activity/post/8394" style="background:#0077b5;color:white;padding:10px 20px;border-radius:4px;text-decoration:none;display:inline-block;">View activity</a>
        </div>
      </div>
  `,
    sender: "LinkedIn Notifications <noreply@Iinkedin.com>",
    isPhishing: true,
    footer: `<div style="font-size:12px;color:#888;padding-top:10px;text-align:center;">
      You're receiving this alert based on your notification settings.<br />
      <a href="https://www.Iinkedin.com/settings/" style="color:#0077b5;text-decoration:underline;">Manage your settings</a>
    </div>`
  },

  {
    id: 6,
    language: "en",
    subject: "Get €10 off your next HelloFresh box",
    body: `
    <div style="text-align:center;">
      <img src="/images/HelloFresh.svg" alt="HelloFresh logo" style="display:block; margin: 0 auto 16px; height: 150px;" />

      <p class="pb-4" style="font-size:15px; line-height:1.6; color:#333;">Dear customer,</p>
      <p class="pb-4" style="font-size:15px; line-height:1.6; color:#333;">
        As a loyal user, we'd like to thank you with a personal discount of <strong>€10</strong> on your next HelloFresh box.
      </p>

      <p style="font-size:15px; line-height:1.6; color:#333;">Use the button below to activate your discount:</p>

      <div style="margin: 20px 0;">
        <a href="https://hellofresh.be/activeren" style="background:#28a745;color:white;padding:12px 20px;border-radius:4px;text-decoration:none;font-weight:bold;">
          Activate my discount
        </a>
      </div>

      <p style="font-size:13px; color:#666;">Discount code: <strong>HF-KERST10</strong></p>
    </div>
  `,
    sender: "HelloFresh Belgium <info@hellofresh.be>",
    isPhishing: false,
    footer: `
    <div style="font-size:12px; color:#888; padding-top:10px; text-align:center;">
      This promotion is valid until December 31 and only available to selected users.<br />
      See the <a href="https://hellofresh.be/voorwaarden" style="color:#28a745; text-decoration:underline;">terms and conditions</a> for more info.
    </div>
  `
  },

  // 7. Social Media – Facebook alert
  {
    id: 7,
    language: "en",
    subject: "You have a new comment on your post",
    body: `
    <div style="text-align:center;">
      <img src="/images/fb.svg" alt="Facebook logo" style="display:block; margin: 0 auto 16px; height:40px;" />
      <p style="font-size:15px; color:#333; line-height:1.6;">
        Someone commented on one of your recent Facebook posts.
      </p>
      <p style="font-size:15px; color:#333; line-height:1.6;">
        View the comment and stay up to date with the discussion.
      </p>
      <div style="margin: 20px 0;">
        <a href="https://facebook-alerts.com/meldingen" style="background:#1877f2;color:white;padding:12px 20px;border-radius:4px;text-decoration:none;font-weight:bold;">
          View alert
        </a>
      </div>
    </div>
  `,
    sender: "Facebook Notifications <no-reply@facebook-alerts.com>",
    isPhishing: true,
    footer: `
    <div style="font-size:12px; color:#888;padding-top:10px; text-align:center;">
      This alert was sent to your account settings.<br />
      Facebook never asks for personal information via email.<br />
      <a href="https://facebook.com/settings/notifications" style="color:#1877f2;text-decoration:underline;">Manage notification settings</a>
    </div>
  `
  },

  // 8. Shipment – Bpost delivery
  {
    id: 8,
    language: "en",
    subject: "Your Bpost delivery is scheduled for tomorrow",
    body: `
    <div style="text-align:center;">
      <img src="/images/bpost.svg" alt="Bpost logo" style="display:block; margin: 0 auto 16px; height: 100px;" />
      <p style="font-size:15px; line-height:1.6; color:#333;">
        Your package is on its way and will be <strong>delivered tomorrow between 09:00 and 13:00</strong>.
      </p>
      <p style="font-size:15px; line-height:1.6; color:#333;">
        You can track your shipment live via the button below.
      </p>
      <div style="margin: 20px 0;">
        <a href="https://track.bpost.be/pakket" style="background:#dc3545;color:white;padding:12px 20px;border-radius:4px;text-decoration:none;font-weight:bold;">
          Track my package
        </a>
      </div>
      <p style="font-size:13px; color:#666;">Tracking number: 1ZA84XF993712736*</p>
    </div>
  `,
    sender: "Bpost Customer Service <info@bpost.be>",
    isPhishing: false,
    footer: `
    <div style="font-size:12px; color:#888;text-align:center;">
      You can track your package up to 7 days after delivery.<br />
      Questions? Check our <a href="https://bpost.be/hulp" style="color:#dc3545; text-decoration:underline;">customer service</a>.
    </div>
  `
  },

  // 9. Energy – Eneco invoice (QR code)
  {
    id: 9,
    language: "en",
    subject: "Your Eneco invoice for this month is available",
    body: `
    <div style="text-align:center;">
      <img src="/images/Eneco.png" alt="Eneco logo" style="display:block; margin: 0 auto 16px; height: 150px;" />
      <p style="font-size:15px; line-height:1.6; color:#333;">
        Your new energy invoice is now available in your customer portal.
      </p>
      <p style="font-size:15px; line-height:1.6; color:#333;">
        You can pay quickly and securely using the QR code below.
      </p>
      <div style="margin: 24px 0;">
        <img src="https://api.qrserver.com/v1/create-qr-code/?data=https://eneco-facturatie.be&size=150x150" alt="QR code for payment" style="display:block; margin: 0 auto;" />
      </div>
      <p style="font-size:13px; color:#666;">Invoice number: ENE-202406-8127</p>
    </div>
  `,
    sender: "Eneco Belgium <facturen@eneco-facturatie.be>",
    isPhishing: true,
    footer: `
    <div style="font-size:12px; color:#888; padding-top:10px; text-align:center;">
      This QR code is valid until the due date shown on your invoice.<br />
      For more information visit <a href="https://www.eneco.be/mijnfacturen" style="color:#e30613;text-decoration:underline;">My Eneco</a>.
    </div>
  `
  }
];

export default emailTemplatesEN;
